import { ImageService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';
import * as IDavis from '@DavisDigital/interfaces';

class CompareImagesModalController {

	public firstImage;
	public secondImage;
	
	public hasDetails = true; 
	
	public showDetails = true;

	// @ngInject
	constructor(
		public ModalService,
		public $element,
		public $window,
		public $q				: ng.IQService,
		public $scope			: ng.IScope,
		public imageService		: ImageService,
		public observerService	: ObserverService
	){}
	
	public $onInit = () => {
		this.hasDetails = this.firstImage.imageName != null ||
						  this.firstImage.artistName != null || 
						  this.secondImage.imageName != null ||
						  this.secondImage.artistName != null;
	}

	public closeAllModals = (event:any):this => {
		let result = {
			event: event,
			message: 'All modals have been closed.'
		};

		this.ModalService.closeModals(result);
		return this;
	}
	
	public toggleDetails = () =>{
		this.showDetails = !this.showDetails;
	}
}

export class CompareImagesModal {
	public restrict: string = 'E';
	public scope: boolean = true;
	public controller: any = CompareImagesModalController;
	public controllerAs: string = 'compareImagesModal';
	public templateUrl: string = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/compare-images-modal.html';
	public bindToController: any = {
		firstImage: '=',
		secondImage: '='
	};

	public static Factory() {
		return () => new this();
	}
}